/* app/js/src/components/monitoring/monitoring.component.scss */
.menu {
  background-color: #232f3a;
  height: 70px;
  border-top: 1px solid #455361;
  text-align: center;
  line-height: 60px;
}
.menu ichannel-link {
  margin-right: 20px;
}
/*# sourceMappingURL=monitoring.component.css.map */
